export enum OpsExceptionType {
  FAILED_TO_PRICE,
  FAILED_TO_TRIGGER,
  FAILED_TO_BOOK,
  NO_ACK_RECEIVED,
  FAILED_SENDING,
  BOOKING_ERROR,
  NACK_RECEIVED,
  FILL_ORDER_NOT_KNOWN,
  FILL_VALUE_DATE_MISMATCH,
  FILL_ACTIVATION_FAIL,
  FILL_MAKER_CANCEL_RCVD,
  CANCEL_ORDER_NOT_KNOWN,
  UNEXPECTED_MAKER_ACTIVATE,
  UNEXPECTED_MAKER_EXPIRY,
  ACTIVATE_ORDER_NOT_KNOWN,
  EXPIRY_ORDER_NOT_KNOWN,
  ORDER_NOT_KNOWN,
  NO_RESPONSE_PLACE,
  NO_RESPONSE_CANCEL,
  TAKER_NAK_EXEC_RPT,
  HUB_PROTO_ERROR,
  EXT_CANCEL_ERROR,
  EXT_CANCEL_REPLACE_ERROR,
  COMP_STATUS_DOWN_ERROR,
  AUTOFILL_FAILED_TO_TRIGGER,
  AUTOFILL_TRIGGER_UNKNOWN_REF,
  AUTOFILL_TRIGGER_UNKNOWN_PAYLOAD,
  ORDER_MIGRATION,
  EXECUTION_STATUS_DOWN_ERROR,
  RATE_STATUS_DOWN_ERROR,
  TG_STATUS_DOWN,
  TG_STATUS_UP,
  RATE_STATUS_UP,
  EXECUTION_STATUS_UP,
  ORDER_MIGRATION_EXECUTED,
  ORDER_MIGRATION_HALTED,
  FEED_FAILED,
  FEED_RECOVERED,
  FEED_MIGRATED,
  BM_HEDGE_ORDER_REJECT,
  SWEPT_PAST_ROLLOVER,
  FAILED_TO_TRIGGER_MANUAL,
  NACK_RECEIVED_CLEAR_ONLY,
  BM_HEDGE_FAIL,
  BM_SWEEP_STARTED,
  MAKER_ACCEPT,
  MAKER_REJECT,
  PAUSE_ORDER_NOT_KNOWN,
  RESUME_ORDER_NOT_KNOWN,
  UNEXPECTED_MAKER_FILL,
  BM_HEDGE_ORDER_TIMEOUT_FAIL,
  BM_HEDGE_ORDER_SWEPT,
  BM_SWEPT_HEDGE_ORDER_FILL,
  UNEXPECTED_MAKER_REJECT,
  BM_SWEEP_SECONDARY_REPRICE,
  AUTO_REJECTED_ORDER,
  AUTO_CANCEL_REJECTED,
  ENTRY_PRICING,
  FAILED_TO_TRIGGER_LIMIT,
  NO_RESPONSE_OCR,
  ORDER_ENTRY,
  NO_RESPONSE_MODIFY,
  NO_RESPONSE_TRANSFER,
  NO_RESPONSE_STEAL,
  MAKER_FILL_ORDER_STILL_ACTIVE,
  AUTO_PAUSE_REJECT,
  AUTO_PAUSE_TIMEOUT,
  AUTO_CANCEL_REJECT,
  AUTO_CANCEL_TIMEOUT,
  MARKUP_CALCULATION,
  UNEXPECTED_MAKER_ROLLBACK,
  FILL_ADJUSTED_VALUE_DATE,
}

export namespace OpsExceptionType {
  let elements = [
    OpsExceptionType.FAILED_TO_PRICE,
    OpsExceptionType.FAILED_TO_TRIGGER,
    OpsExceptionType.FAILED_TO_BOOK,
    OpsExceptionType.NO_ACK_RECEIVED,
    OpsExceptionType.FAILED_SENDING,
    OpsExceptionType.BOOKING_ERROR,
    OpsExceptionType.NACK_RECEIVED,
    OpsExceptionType.FILL_ORDER_NOT_KNOWN,
    OpsExceptionType.FILL_VALUE_DATE_MISMATCH,
    OpsExceptionType.FILL_ACTIVATION_FAIL,
    OpsExceptionType.FILL_MAKER_CANCEL_RCVD,
    OpsExceptionType.CANCEL_ORDER_NOT_KNOWN,
    OpsExceptionType.UNEXPECTED_MAKER_ACTIVATE,
    OpsExceptionType.UNEXPECTED_MAKER_EXPIRY,
    OpsExceptionType.ACTIVATE_ORDER_NOT_KNOWN,
    OpsExceptionType.EXPIRY_ORDER_NOT_KNOWN,
    OpsExceptionType.ORDER_NOT_KNOWN,
    OpsExceptionType.NO_RESPONSE_PLACE,
    OpsExceptionType.NO_RESPONSE_CANCEL,
    OpsExceptionType.TAKER_NAK_EXEC_RPT,
    OpsExceptionType.HUB_PROTO_ERROR,
    OpsExceptionType.EXT_CANCEL_ERROR,
    OpsExceptionType.EXT_CANCEL_REPLACE_ERROR,
    OpsExceptionType.COMP_STATUS_DOWN_ERROR,
    OpsExceptionType.AUTOFILL_FAILED_TO_TRIGGER,
    OpsExceptionType.AUTOFILL_TRIGGER_UNKNOWN_REF,
    OpsExceptionType.AUTOFILL_TRIGGER_UNKNOWN_PAYLOAD,
    OpsExceptionType.ORDER_MIGRATION,
    OpsExceptionType.EXECUTION_STATUS_DOWN_ERROR,
    OpsExceptionType.RATE_STATUS_DOWN_ERROR,
    OpsExceptionType.TG_STATUS_DOWN,
    OpsExceptionType.TG_STATUS_UP,
    OpsExceptionType.RATE_STATUS_UP,
    OpsExceptionType.EXECUTION_STATUS_UP,
    OpsExceptionType.ORDER_MIGRATION_EXECUTED,
    OpsExceptionType.ORDER_MIGRATION_HALTED,
    OpsExceptionType.FEED_FAILED,
    OpsExceptionType.FEED_RECOVERED,
    OpsExceptionType.FEED_MIGRATED,
    OpsExceptionType.BM_HEDGE_ORDER_REJECT,
    OpsExceptionType.SWEPT_PAST_ROLLOVER,
    OpsExceptionType.FAILED_TO_TRIGGER_MANUAL,
    OpsExceptionType.NACK_RECEIVED_CLEAR_ONLY,
    OpsExceptionType.BM_HEDGE_FAIL,
    OpsExceptionType.BM_SWEEP_STARTED,
    OpsExceptionType.MAKER_ACCEPT,
    OpsExceptionType.MAKER_REJECT,
    OpsExceptionType.PAUSE_ORDER_NOT_KNOWN,
    OpsExceptionType.RESUME_ORDER_NOT_KNOWN,
    OpsExceptionType.UNEXPECTED_MAKER_FILL,
    OpsExceptionType.BM_HEDGE_ORDER_TIMEOUT_FAIL,
    OpsExceptionType.BM_HEDGE_ORDER_SWEPT,
    OpsExceptionType.BM_SWEPT_HEDGE_ORDER_FILL,
    OpsExceptionType.UNEXPECTED_MAKER_REJECT,
    OpsExceptionType.BM_SWEEP_SECONDARY_REPRICE,
    OpsExceptionType.AUTO_REJECTED_ORDER,
    OpsExceptionType.AUTO_CANCEL_REJECTED,
    OpsExceptionType.ENTRY_PRICING,
    OpsExceptionType.FAILED_TO_TRIGGER_LIMIT,
    OpsExceptionType.NO_RESPONSE_OCR,
    OpsExceptionType.ORDER_ENTRY,
    OpsExceptionType.NO_RESPONSE_MODIFY,
    OpsExceptionType.NO_RESPONSE_TRANSFER,
    OpsExceptionType.NO_RESPONSE_STEAL,
    OpsExceptionType.MAKER_FILL_ORDER_STILL_ACTIVE,
    OpsExceptionType.AUTO_PAUSE_REJECT,
    OpsExceptionType.AUTO_PAUSE_TIMEOUT,
    OpsExceptionType.AUTO_CANCEL_REJECT,
    OpsExceptionType.AUTO_CANCEL_TIMEOUT,
    OpsExceptionType.MARKUP_CALCULATION,
    OpsExceptionType.UNEXPECTED_MAKER_ROLLBACK,
    OpsExceptionType.FILL_ADJUSTED_VALUE_DATE,
  ];
  let alias = "com.bcdfx.model.OpsExceptionType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
